import { FC } from "react";
import PricingSubTableArabic from "./PrcingSubTableArabic";

interface PricingTableArabicProps {
    growthPrice: string;
    scalePrice: string;
    proPrice: string;
}

interface TableInternalContentProps {
    title: string;
    growth: string;
    scale: string;
    pro: string;
    growthTooltip?: string;
    scaleTooltip?: string;
    proTooltip?: string;
    tooltip?: any;
}

interface PricingTableArabicDataProps {
    tableTitle: string;
    tableInternalContent: TableInternalContentProps[];
}

const PricingTableArabicData: PricingTableArabicDataProps[] = [
    {
        tableTitle: "الأساسيات",
        tableInternalContent: [
            {
                pro: "حتى 6 مستخدمين",
                tooltip: "تطبيق الهاتف المحمول - الأندرويد والآي أو إس",
                growth: "حتى 6 مستخدمين",
                scale: "حتى 6 مستخدمين",
                title: "عدد المستخدمين",
            },
            {
                pro: "yes.png",
                tooltip: "التعاون بسلاسة مع فريقك من خلال الوصول إلى ...w والرد على الرسائل في موقع مركزي واحد",
                growth: "yes.png",
                scale: "yes.png",
                title: "البريد الوارد للفريق المشترك",
            },
            {
                pro: "yes.png",
                tooltip: "تعيين الردود الجاهزة للأسئلة الأكثر شيوعًا، والتذكيرات، وتحديثات الطلبات، ورسائل الترحيب، والمزيد",
                growth: "yes.png",
                scale: "yes.png",
                title: "Canned response",
            },
            {
                pro: "yes.png",
                tooltip: "إضافة رقم واجهة برمجة التطبيقات للواتساب إضافي إلى حسابك",
                growth: "yes.png",
                scale: "yes.png",
                title: "أرقام واتساب متعددة",
            },
            {
                pro: "15",
                tooltip: "الرد بسلاسة على عملائك عبر تطبيق الهاتف المحمول",
                growth: "10",
                scale: "5",
                title: "تطبيق الهاتف المحمول - الأندرويد والآي أو إس",
            },
            {
                pro: "no.png",
                tooltip: "إنشاء البيانات وتخزينها في أسماء الحقول المخصصة بناءً على متطلبات عملك. مثل رقم الحساب الدائم، والرقم الضريبي للسلع والخدمات",
                growth: "yes.png",
                scale: "yes.png",
                title: "حقول مخصصة",
            },

            {
                pro: "no.png",
                tooltip: "إعادة كتابة الرسائل لجعلها أكثر وضوحًا أو إيجازًا أو جاذبية باستخدام Gallabox GPT",
                growth: "yes.png",
                scale: "yes.png",
                title: "إعادة كتابة الذكاء الاصطناعي",
            },
            {
                pro: "6",
                tooltip: "أنشئ أدوارًا بأذونات مخصصة وفقًا لمتطلباتك",
                growth: "3",
                scale: "no.png",
                title: "الأدوار المخصصة",
            },
            {
                pro: "5",
                tooltip: "قم بإنشاء فرق مع المستخدمين لديك لإدارة المحادثات بكفاءة.",
                growth: "3",
                scale: "no.png",
                title: "فرق المستخدم",
            },
        ],
    },
    {
        tableTitle: "التسويق",
        tableInternalContent: [
            {
                pro: "عبر المقاطع والإكسل وواجهة برمجة التطبيقات",
                tooltip: "أرسل قالبًا واحدًا إلى مجموعة كبيرة من المستلمين بشكل فوري وبنقرة واحدة",
                growth: "عبر المقاطع والإكسل",
                scale: "عبر المقاطع",
                title: "حملات البث الجماعي",
            },

            {
                pro: "غير محدود",
                tooltip: "بناءً على حد رسائل Meta في اليوم",
                growth: "100,000 / اليوم",
                scale: "10,000 / اليوم",
                title: "حد البث",
            },
            {
                pro: "yes.png",
                tooltip: "احصل على موافقة على التواصل أو إرسال المواد التسويقية إلى عملائك",
                growth: "yes.png",
                scale: "yes.png",
                title: "إدارة الاختيار",
            },
            {
                pro: "20 حملة",
                tooltip: "إرسال رسائل آلية على فترات منتظمة، مثل يوميًا أو أسبوعيًا أو شهريًا",
                growth: "10 حملات",
                scale: "no.png",
                title: "التسويق بالتنقيط (التسلسل)",
            },

            {
                pro: "yes.png",
                tooltip: "تعقب إعلانات أنقر للدخول إلى واتساب داخل Gallabox",
                growth: "yes.png",
                scale: "no.png",
                title: "CTWA (تتبع إعلانات الفيسبوك)",
            },

            {
                pro: "yes.png",
                tooltip: "تعيين للوكيل أو الروبوت أو الفريق",
                growth: "yes.png",
                scale: "no.png",
                title: "الرد على التكوين",
            },
            {
                pro: "yes.png",
                tooltip: "تعقب النقرات على الزر الخاص بك في رسائل القالب",
                growth: "yes.png",
                scale: "no.png",
                title: "متعقب الرسائل",
            },
        ],
    },
    {
        tableTitle: "روبوت الدردشة",
        tableInternalContent: [
            {
                pro: "10 روبوتات",
                tooltip: "أنشئ روبوت دردشة واتساب مخصص باستخدام أدوات السحب والإسقاط",
                growth: "5 روبوتات",
                scale: "3 روبوتات",
                title: "الروبوتات",
            },
            {
                pro: "yes.png",
                tooltip: "تفاعل مع عملائك بلغتهم الأم باستخدام روبوت الدردشة الخاص بنا",
                growth: "yes.png",
                scale: "yes.png",
                title: "روبوت الدردشة متعدد اللغات",
            },

            {
                pro: "yes.png",
                tooltip: "وصّل أدواتك الحالية مع Gallabox Bot",
                growth: "yes.png",
                scale: "no.png",
                scaleTooltip: "API Call, Google Sheets, Razorpay, Zoho CRM, Shopify, Bigin by Zoho, WooCommerce, Sangam CRM",
                title: "موصلات الروبوت",
                proTooltip: "Hubspot, LeadSquared, Open AI, Zoom",
            },
            {
                pro: "yes.png",
                tooltip: "قم بتعيين محادثة لفريق أو فرد معين باستخدام روبوت الدردشة",
                growth: "yes.png",
                scale: "no.png",
                title: "أفعال الروبوت",
            },
            {
                pro: "yes.png",
                tooltip: "ينبغي تعيين التأخير والشروط والانتقال إلى التدفقات وتبديلها",
                growth: "yes.png",
                scale: "no.png",
                title: "منافع الروبوت",
            },
            {
                pro: "yes.png",
                tooltip: "ينبغي التكامل مع الذكاء الاصطناعي المفتوح لفتح المحادثات المستندة إلى الذكاء الاصطناعي",
                growth: "no.png",
                scale: "no.png",
                title: "موصّل الذكاء الاصطناعي المفتوح (ChatGPT)",
            },
        ],
    },

    {
        tableTitle: "التجارة",
        tableInternalContent: [
            {
                pro: "yes.png",
                tooltip: "وصّل متجر التجارة الإلكترونية الخاص بك بواتساب",
                growth: "yes.png",
                scale: "yes.png",
                title: "متجر واتساب",
            },

            {
                pro: "yes.png",
                tooltip: "أرسل روابط سداد إلى العملاء المشغولين",
                growth: "no.png",
                scale: "yes.png",
                title: "روابط السداد",
            },
        ],
    },
    {
        tableTitle: "التحليلات",
        tableInternalContent: [
            {
                pro: "متقدم",
                tooltip: "قم بتجميع وتحليل وتفسير البيانات من محادثات واتساب الخاصة بك",
                growth: "متقدم",
                scale: "أساسي",
                title: "تحليلات المحادثات",
            },

            {
                pro: "yes.png",
                tooltip: "قِس فعالية حملاتك باستخدام الرؤى المستندة إلى البيانات",
                growth: "yes.png",
                scale: "yes.png",
                title: "تحليلات الحملات",
            },

            {
                pro: "yes.png",
                tooltip: "أفهم أداء الروبوتات وحدد الاتجاهات وقم بإجراء التحسينات",
                growth: "no.png",
                scale: "no.png",
                title: "تحليلات الروبوت",
            },
        ],
    },
    {
        tableTitle: "واجهة برمجة التطبيقات وخطافات الويب",
        tableInternalContent: [
            {
                pro: "متقدم",
                tooltip: "تزامن بسلاسة مع أدوات الطرف الثالث الخاصة بك",
                growth: "الرسائل، واجهة برمجة تطبيقات جهات الاتصال",
                growthTooltip: "Message API, Contact API",
                scale: "أساسي",
                scaleTooltip: "Webhook, Broadcast API, Template API",
                title: "قدرات واجهة برمجة التطبيقات",
                proTooltip: "Webhook, Broadcast API, Template API",
            },
            {
                pro: "متوسط",
                tooltip: "سهّل تبادل البيانات بين Gallabox وأي منصة",
                growth: "اتصال",
                growthTooltip: "Contact",
                scale: "أساسي",
                scaleTooltip: "Message, WA.Stat, Conversation",
                title: "خطافات الويب",
                proTooltip: "Message Received , Template",
            },
            {
                pro: "1000",
                tooltip: "عدد مكالمات أو طلبات واجهة برمجة التطبيقات خلال دقيقة واحدة",
                growth: "500",
                scale: "200",
                title: "مكالمات واجهة برمجة التطبيقات / الدقيقة",
            },
        ],
    },
    {
        tableTitle: "عمليات التكامل",
        tableInternalContent: [
            {
                pro: "yes.png",
                tooltip: "اتصل بشوبيفاي لمشاركة تحديثات الطلب",
                growth: "yes.png",
                scale: "yes.png",
                title: "شوبيفاي",
            },
            {
                pro: "yes.png",
                tooltip: "أرسل تنبيهات وتنويهات بحالة طلب ووكمرس ",
                growth: "yes.png",
                scale: "yes.png",
                title: "ووكمرس",
            },
            {
                pro: "متقدم",
                tooltip: "احصل على مصدر واحد للحقيقة من خلال مزامنة سلسة ثنائية الاتجاه بين Gallabox وإدارة علاقات عملاء زوهو",
                growth: "متقدم",
                scale: "أساسي",
                title: "إدارة علاقات عملاء زوهو",
            },
            {
                pro: "yes.png",
                tooltip: "أشرك جهات اتصال HubSpot بشكل أفضل من خلال سير عمل واتساب المبسط",
                growth: "yes.png",
                scale: "no.png",
                title: "هاب سبوت",
            },
            {
                pro: "yes.png",
                tooltip: "تفاعل مع العملاء المتوقعين والعملاء المحتملين في إدارة علاقات العملاء LeadSquared على واتساب",
                growth: "no.png",
                scale: "no.png",
                title: "LeadSquared",
            },
            {
                pro: "yes.png",
                tooltip: "تفاعل مع العملاء المتوقعين والعملاء المحتملين في Kylas على واتساب",
                growth: "yes.png",
                scale: "yes.png",
                title: "Kylas",
            },
            {
                pro: "yes.png",
                tooltip: "وسّع وظائف إدارة علاقات عملاء سانجام لديك من خلال التفاعل مع العملاء المحتملين على واتساب",
                growth: "yes.png",
                scale: "yes.png",
                title: "سانجام",
            },
            {
                pro: "yes.png",
                tooltip: "أرسل أو أجلب البيانات من جدول بيانات جوجل",
                growth: "yes.png",
                scale: "yes.png",
                title: "أودو",
            },
            {
                pro: "yes.png",
                tooltip: "شغِّل رسائل واتساب تلقائيًا لطلبات المبيعات/ عروض الأسعار والفواتير الأولية وقسائم التسليم",
                growth: "no.png",
                scale: "no.png",
                title: "Odoo",
            },
            {
                pro: "yes.png",
                tooltip: "شغِّل رسائل واتساب تلقائيًا للمدفوعات المستلمة والمدفوعات الفاشلة والاستردادات المنفذة",
                growth: "yes.png",
                scale: "yes.png",
                title: "Razorpay",
            },
            {
                pro: "yes.png",
                tooltip: "شغِّل رسائل واتساب تلقائيًا للمدفوعات الناجحة والفاشلة",
                growth: "yes.png",
                scale: "no.png",
                title: "CashFree",
            },
            {
                pro: "قريبًا",
                tooltip: "شغِّل رسائل واتساب تلقائيًا للمدفوعات المستلمة والمدفوعات الفاشلة والاستردادات المنفذة",
                growth: "no.png",
                scale: "no.png",
                title: "PayU",
            },
            {
                pro: "yes.png",
                tooltip: "قم بتوصيل نماذج FB Lead الخاصة بك بـ Gallabox وتشغيل الرسالة على الفور",
                growth: "yes.png",
                scale: "yes.png",
                title: "FB Leads",
            },
            {
                pro: "yes.png",
                tooltip: "أرسل رسائل بث مستهدفة دون مغادرة WebEngage",
                growth: "no.png",
                scale: "no.png",
                title: "WebEngage",
            },
            {
                pro: "yes.png",
                tooltip: "أرسل رسائل بث مخصصة دون مغادرة MoEngage",
                growth: "no.png",
                scale: "no.png",
                title: "MoEngage",
            },
            {
                pro: "yes.png",
                tooltip: "تواصل مع أكثر من 1000 تطبيق بسهولة. ما عليك سوى اختيار التطبيق وستكون جاهزًا للبدء",
                growth: "yes.png",
                scale: "yes.png",
                title: "Pabbly",
            },
            {
                pro: "yes.png",
                tooltip: "حصّل المدفوعات وأحجز المواعيد وأرسل الخصومات وحدث حالة العميل المحتمل تلقائيًا عبر زابير",
                growth: "yes.png",
                scale: "yes.png",
                title: "Zapier",
            },
            {
                pro: "yes.png",
                tooltip: "قم بأتمتة تذكيرات مواعيدك وإعادة جدولة الإشعارات عبر واتساب",
                growth: "yes.png",
                scale: "no.png",
                title: "Calendly",
            },
            {
                pro: "yes.png",
                tooltip: "قم بأتمتة التذكيرات وتعليقات الندوات عبر الويب على واتساب",
                growth: "yes.png",
                scale: "no.png",
                title: "Zoho Meetings",
            },
            {
                pro: "yes",
                tooltip: "أرسل رسائل واتساب مخصصة للتأكيد والتذكير بالمواعيد",
                growth: "yes.png",
                scale: "no.png",
                title: "Zoho Bookings",
            },
            {
                pro: "yes.png",
                tooltip: "أرسل رسائل واتساب مخصصة لطلب المبيعات/عروض الأسعار والفواتير الأولية",
                growth: "yes.png",
                scale: "no.png",
                title: "زوهو بوكس",
            },
            {
                pro: "yes.png",
                tooltip: "شارك حالة الطلب في الوقت الفعلي على الفور (تم الشحن، جاهز للاستلام، خرج للتسليم، تم التسليم، تم إعادة الجدولة)",
                growth: "yes.png",
                scale: "yes.png",
                title: "Shiprocket",
            },
            {
                pro: "قريبًا",
                tooltip: "شارك حالة الطلب في الوقت الفعلي على الفور (تم الشحن، خرج للتسليم، تم التسليم)",
                growth: "قريبًا",
                scale: "no.png",
                title: "Shipway",
            },
            {
                title: "Shoplo",
                tooltip: " Send automated WhatsApp triggers for abandoned carts.",
                growth: "yes.png",
                scale: "no.png",
                pro: "no.png",
            },
            {
                title: "CleverTap",
                tooltip: " Send personalized WhatsApp campaigns, track stats, and automate workflows",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Stripe",
                tooltip: "Automatically trigger WhatsApp messages for Payment captured, failed & refund processed",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                pro: "yes.png",
                tooltip: "ألا يمكنك العثور على اتصال مباشر لتطبيقك المفضل؟ يسعدنا إنشاء واحدًا لك.",
                growth: "no.png",
                scale: "no.png",
                title: "Custom Integration",
            },
        ],
    },
];

const PricingTableArabic: FC<PricingTableArabicProps> = ({ growthPrice, scalePrice, proPrice }) => {
    return (
        <div className="pricing-table-section bg-zircon" style={{ maxWidth: "1166px", margin: "auto" }}>
            <div
                style={{ top: "67px" }}
                className="bg-gray-200 pt-10  hidden pricing-table-outer-sticky lg:flex flex-row-reverse none md: pricing-table border-gray-200 border border-solid z-3"
            >
                <div className="w-1/4 text-right ">
                    <p className=" text-3xl font-medium pt-2">مقارنة الخطة</p>
                    <p className=" text-lg text-gray-700 pt-2">ابحث عن أفضل اشتراك لديك.</p>
                </div>
                <Stickyheadertitle plan={"النمو"} amount={growthPrice} />
                <Stickyheadertitle plan={"الحجم"} amount={scalePrice} />
                <Stickyheadertitle plan={"الاحترافي"} amount={proPrice} />
            </div>

            {PricingTableArabicData.map((data) => {
                return (
                    <PricingSubTableArabic
                        key={data.tableTitle}
                        growthPrice={growthPrice}
                        scalePrice={scalePrice}
                        tableTitle={data.tableTitle}
                        proPrice={proPrice}
                        tableInternalData={data.tableInternalContent}
                    />
                );
            })}
        </div>
    );
};
interface stickyheadertitleProps {
    plan: string;
    amount: string | undefined;
}
export const Stickyheadertitle: FC<stickyheadertitleProps> = ({ plan, amount }) => {
    return (
        <div className="sticky-header sticky top-0 gap-2 lg:w-1/4">
            <p className="text-sm font-medium mt-1.5 text-gray-700">{plan}</p>
            <p className="text-xl font-bold">{amount}</p>
            <div className="pb-1.5">
                <a className="try-btn " href="https://app.gallabox.com/signup" style={{ color: "white", outline: "none", background: "#3182CE" }}>
                    Get Started
                </a>
            </div>
        </div>
    );
};

export default PricingTableArabic;
